export default "__VITE_ASSET__DabROXlv__"